import { render, staticRenderFns } from "../ItemSelectModal.html?vue&type=template&id=035f8b1b&scoped=true&external"
import script from "./WorkItemSelectModal.ts?vue&type=script&lang=ts&external"
export * from "./WorkItemSelectModal.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkItemSelectModal.scss?vue&type=style&index=0&id=035f8b1b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f8b1b",
  null
  
)

export default component.exports